<template>
    <section class="pb-2">
        <div v-html="body" class="text-content" :class="[data.align, columns]"></div>
    </section>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    body () {
      return this.data.body
    },
    columns () {
      if (this.data.columns === 2) {
        return '@md:columns-2'
      }
      if (this.data.columns === 3) {
        return '@md:columns-2 @lg:columns-3'
      }
      return null
    }
  },
  methods: {
  }
}
</script>
